Vue.component('file-upload', {
    template: templates.uploadComponent,
    props: {
        //Existing images
        existingImages: {
            type: Object,
            default: () => {}
        },
        allowRemoveExisting: {
            type: Boolean,
            default: true
        },
        imageBaseUrl: {
            type: String,
            default: '/uploads/' 
        },
        // Whether to allow multiple files
        multiple: {
            type: Boolean,
            default: false
        },
        // Upload type (e.g., 'cards', 'users', etc.)
        uploadType: {
            type: String,
            required: true
        },
        // ID for the upload (e.g., card ID, user ID)
        uploadId: {
            type: [String, Number],
            required: true
        },
        // Accepted file types (e.g., 'image/*', 'video/*', '.jpg,.png,.mp4')
        acceptedTypes: {
            type: String,
            default: 'image/*,video/*'
        },
        // Maximum file size in bytes
        maxSize: {
            type: Number,
            default: 50 * 1024 * 1024 // 50MB default for video support
        },
        // Auto upload when files are selected
        autoUpload: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectedFiles: [],
            dragOver: false,
            uploadProgress: {
                active: false,
                percent: 0,
                text: 'Uploading...',
                currentFile: '',
                totalFiles: 0,
                currentFileIndex: 0
            }
        }
    },
    computed: {
        canUpload() {
            return this.selectedFiles.length > 0 && this.uploadId;
        },
        acceptedTypesText() {
            if (!this.acceptedTypes) return '';
            return this.acceptedTypes
                .split(',')
                .map(type => type.trim().replace(/\*/g, '').replace(/\./g, '').toUpperCase())
                .join(', ');
        },
        progressText() {
            if (!this.uploadProgress.active) return '';
            
            const { currentFile, currentFileIndex, totalFiles, percent } = this.uploadProgress;
            
            if (totalFiles > 1) {
                return `Uploading ${currentFile} (${currentFileIndex}/${totalFiles}) - ${percent}%`;
            }
            
            return `Uploading ${currentFile} - ${percent}%`;
        }
    },
    watch: {
        selectedFiles(newFiles) {
            if (this.autoUpload && newFiles.length > 0) {
                this.uploadFiles();
            }
        }
    },
    methods: {
        triggerFileInput() {
            this.$refs.fileInput.click();
        },

        handleFileSelect(event) {
            this.processFiles(Array.from(event.target.files));
        },

        handleDragEnter(event) {
            event.preventDefault();
            this.dragOver = true;
        },

        handleDragOver(event) {
            event.preventDefault();
        },

        handleDragLeave(event) {
            event.preventDefault();
            if (!event.currentTarget.contains(event.relatedTarget)) {
                this.dragOver = false;
            }
        },

        handleFileDrop(event) {
            event.preventDefault();
            this.dragOver = false;
            this.processFiles(Array.from(event.dataTransfer.files));
        },

        processFiles(files) {
            const validFiles = [];
            for (let file of files) {
                // Validate file type
                if (!this.isValidFileType(file)) {
                    utils.alert.error(`Invalid file type: ${file.name}. Accepted types: ${this.acceptedTypesText}`);
                    continue;
                }

                // Validate file size
                if (file.size > this.maxSize) {
                    utils.alert.error(`File too large: ${file.name} (${this.formatFileSize(file.size)}). Max size: ${this.formatFileSize(this.maxSize)}`);
                    continue;
                }

                validFiles.push(file);
            }

            // If not multiple, keep only the last file
            if (!this.multiple && validFiles.length > 0) {
                this.selectedFiles = [];
            }

            // Process valid files
            validFiles.forEach(file => {
                const fileObj = {
                    file: file,
                    name: file.name,
                    size: file.size,
                    type: file.type,
                    preview: null,
                    isVideo: this.isVideo(file),
                    isImage: this.isImage(file)
                };

                // Create preview for images
                if (this.isImage(file)) {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        fileObj.preview = e.target.result;
                    };
                    reader.readAsDataURL(file);
                } else if (this.isVideo(file)) {
                    // For videos, you might want to create a thumbnail or use a video icon
                    fileObj.preview = null; // Could set a video icon path here
                }

                this.selectedFiles.push(fileObj);
            });

            // Clear file input
            this.$refs.fileInput.value = '';
        },

        removeFile(index) {
            this.selectedFiles.splice(index, 1);
        },

        clearFiles() {
            const c = this;
            c.selectedFiles = [];
            c.clearFileInput();
        },

        clearFileInput() {
            
            this.$nextTick(() => {
                if (this.$refs.fileInput) {
                    this.$refs.fileInput.value = '';
                }
            });
        },

        async uploadFiles() {
            const c = this;
            if (!c.canUpload) return;

            c.uploadProgress.active = true;
            c.uploadProgress.percent = 0;
            c.uploadProgress.totalFiles = c.selectedFiles.length;
            c.uploadProgress.currentFileIndex = 0;

            try {
                let results = [];
                const isMultipleUpload = c.selectedFiles.length > 1;

                console.log(c.uploadType)

                if (isMultipleUpload && (c.uploadType === 'announcement' || c.uploadType === 'chest' || c.uploadType === 'medals' || c.uploadType === 'frames')) {
                    // For multiple files, use batch upload
                    c.uploadProgress.currentFile = `${c.selectedFiles.length} files`;
                    c.uploadProgress.currentFileIndex = 1;

                    const result = await c.uploadMultipleFiles();
                    if (result) {
                        results = result.files;
                    }

                    console.log('a')
                } else {
                    // Single file upload or non-batch uploads (one by one)
                    for (let i = 0; i < c.selectedFiles.length; i++) {
                        const fileObj = c.selectedFiles[i];
                        
                        c.uploadProgress.currentFile = fileObj.name;
                        c.uploadProgress.currentFileIndex = i + 1;
                        c.uploadProgress.percent = 0; // Reset for each file

                        const result = await c.uploadSingleFile(fileObj.file, i);
                        if (result) {
                            results.push(result);
                        }
                    }
                    console.log('b')
                }

                c.uploadProgress.active = false;
                if (results.length > 0) {
                    utils.alert.success(`Successfully uploaded ${results.length} file(s)!`);
                    
                    // Emit success event with results
                    c.$emit('upload-success', {
                        files: results,
                        type: c.uploadType,
                        id: c.uploadId
                    });


                    c.clearFiles();

                }

            } catch (error) {
                c.uploadProgress.active = false;
                console.error('Upload error:', error);
                utils.alert.error('Upload failed: ' + (error.message || 'Unknown error'));

                // Emit error event
                c.$emit('upload-error', error);
            }
        },

        uploadSingleFile(file, index) {
            const c = this;
            return new Promise((resolve, reject) => {
                const formData = new FormData();
                formData.append('file', file);
                formData.append('type', c.uploadType);
                formData.append('id', c.uploadId);

                // Use uploadService for file upload with progress
                uploadService.uploadFileWithProgress(formData, (progressEvent) => {
                    if (progressEvent.lengthComputable) {
                        const percentComplete = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                        c.uploadProgress.percent = percentComplete;
                    }
                })
                .then(function (response) {
                    resolve(response.data || response);
                })
                .catch(function (error) {
                    console.error('Upload error for file:', file.name, error);
                    reject(error);
                });
            });
        },

        uploadMultipleFiles() {
            const c = this;
            const formData = new FormData();
            
            this.selectedFiles.forEach((fileObj, index) => {
                formData.append('files[]', fileObj.file);
            });
            formData.append('type', c.uploadType);
            formData.append('id', c.uploadId);

            return new Promise((resolve, reject) => {
                uploadService.uploadMultipleFile(formData, (progressEvent) => {
                    if (progressEvent.lengthComputable) {
                        const percentComplete = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                        c.uploadProgress.percent = percentComplete;
                    }
                })
                .then(function (response) {
                    resolve(response.data || response);
                })
                .catch(function (error) {
                    console.error('Multiple upload error:', error);
                    reject(error);
                });
            });
        },

        isValidFileType(file) {
            const c = this;
            if (!c.acceptedTypes) return true;

            const acceptedTypes = c.acceptedTypes.split(',').map(type => type.trim());

            for (let type of acceptedTypes) {
                if (type === '*/*') return true;
                
                if (type.endsWith('/*')) {
                    // Handle mime type wildcards like 'image/*', 'video/*'
                    const mimeType = type.replace('/*', '');
                    if (file.type.startsWith(mimeType)) return true;
                } else if (type.startsWith('.')) {
                    // Handle file extensions like '.jpg', '.mp4'
                    const ext = type.toLowerCase();
                    if (file.name.toLowerCase().endsWith(ext)) return true;
                } else if (file.type === type) {
                    // Handle exact mime types like 'image/jpeg'
                    return true;
                }
            }

            return false;
        },

        isImage(file) {
            return file.type.startsWith('image/');
        },

        isVideo(file) {
            return file.type.startsWith('video/');
        },

        getFileTypeIcon(fileObj) {
            if (fileObj.isImage) {
                return 'fa-image'; // FontAwesome icon class
            } else if (fileObj.isVideo) {
                return 'fa-video';
            }
            return 'fa-file';
        },

        formatFileSize(bytes) {
            if (bytes === 0) return '0 Bytes';

            const k = 1024;
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));

            return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
        },
        getImageUrl(image) {
            // Handle different image data structures
            if (typeof image === 'string') {
              return this.imageBaseUrl + image;
            }
            if (image.url) {
              return image.url;
            }
            if (image.path) {
              return this.imageBaseUrl + image.path;
            }
            if (image.filename) {
              return this.imageBaseUrl + image.filename;
            }
            return image.src || image;
        },
        
        removeExistingImage(img, index) {
            const c = this;
            const data = {
                image : img,
                index: Number(index)
            }
            c.$root.$emit('remove-existing-image', data);
        }
        
    },
});